import React from 'react'
import Box from '@mui/material/Box'
import { useAlertContext } from '../contexts/AlertContext'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'

function AlertFilterView() {
  const { searchTerm, setSearchTerm } = useAlertContext()

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  return (
    <Box flexBasis={300} flexShrink={1}>
      <TextField
        fullWidth
        size="small"
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Search alerts..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ opacity: 0.5 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'background.custom3',
            borderRadius: '8px',
            '& fieldset': {
              borderColor: 'transparent',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.1)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'primary.main',
              borderWidth: '1px',
            },
          },
        }}
      />
    </Box>
  )
}

export default AlertFilterView
